import styled from "styled-components"

export const Wrapper = styled.header`
  -webkit-clip-path: polygon(100% 0, 0 0, 0 70%, 50% 100%, 100% 70%);
  clip-path: polygon(100% 0, 0 0, 0 70%, 50% 100%, 100% 70%);
  @media (max-width: 600px) {
    -webkit-clip-path: polygon(100% 0, 0 0, 0 90%, 50% 100%, 100% 90%);
    clip-path: polygon(100% 0, 0 0, 0 90%, 50% 100%, 100% 90%);
  }
  background: linear-gradient(45deg, #04d361 0%, #00c853  100%);
  height: 230px;
  position: relative;
  overflow: hidden;
`

export const Text = styled.div`
  color: #fff;
  z-index: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  max-width: 70rem;
  padding: 0 2rem;
  margin-top: 2rem;
  margin-bottom: 3rem;
  align-items: center;
  h1 {
    background-color: #222;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    color: #00c853;
  }
`
